import { TFunction } from 'i18next'
import AdminRestService from '../rest/AdminRestService'
import RoleService from './RoleService'

class AdminService {
  static async getAdmins(setAdmins?: React.Dispatch<any>) {
    if (setAdmins) {
      const admins = await AdminRestService.get()
      setAdmins(admins)
    } else {
      return AdminRestService.get()
    }
  }

  static async createAdmin(admin: any, t: TFunction, setAdmins?: React.Dispatch<any>) {
    try {
      const editedAdmin = await AdminRestService.create(admin)
      await AdminService.getAdmins(setAdmins)
      return t('admin.createSuccess', { name: editedAdmin.username, tempPassword: admin.password })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async updateAdmin(admin: any, t: TFunction, setAdmins?: React.Dispatch<any>) {
    try {
      const editedAdmin = await AdminRestService.update(admin)
      await AdminService.getAdmins(setAdmins)
      return t('admin.editSuccess', { name: editedAdmin.username })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async resetAdmin(admin: any, t: TFunction) {
    try {
      await AdminRestService.update(admin)
      return t('admin.resetSuccess', { name: admin.username, tempPassword: admin.password })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async deleteAdmin(admin: any, t: TFunction, setAdmins?: React.Dispatch<any>) {
    try {
      await AdminRestService.delete(admin.id)
      await AdminService.getAdmins(setAdmins)
      return t('admin.deleteSuccess', { name: admin.username })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async getRolesWithAssigned(id: number) {
    const allRoles: any[] = await RoleService.get()
    const adminRoles: any[] = await AdminRestService.getAssignedRoles(id)

    const adminRoleIds: number[] = adminRoles.map((role: { id: any }) => role.id)
    allRoles.forEach((role) => {
      if (adminRoleIds.includes(role.id)) {
        role.isAssigned = true
      } else {
        role.isAssigned = false
      }
    })
    return allRoles
  }

  static async assignRoles(roles: any[], adminId: number, adminName: string, t: TFunction) {
    await AdminRestService.updateAssignedRoles(
      adminId,
      roles.filter((role) => role.isAssigned).map((role) => role.id)
    )
    return t('admin.assignRolesSuccess', { name: adminName })
  }
}

export default AdminService
